/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconChevronsDownLeft = createReactComponent(
  "chevrons-down-left",
  "IconChevronsDownLeft",
  [
    ["path", { d: "M11 5v8h8", key: "svg-0" }],
    ["path", { d: "M7 9v8h8", key: "svg-1" }]
  ]
);

export { IconChevronsDownLeft as default };
//# sourceMappingURL=IconChevronsDownLeft.js.map
